"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-expressions */
const react_1 = require("react");
const validatorus_react_1 = require("validatorus-react");
const ton_1 = require("ton");
const ton3_1 = require("ton3");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const react_i18next_1 = require("react-i18next");
const de_ui_1 = require("@delab-team/de-ui");
const protocol_1 = require("@tonconnect/protocol");
const getClient_1 = require("../../../utils/getClient");
const modal_1 = require("../../../components/ui/modal");
const SendTransactionError_1 = require("../../../logic/tonconnect/SendTransactionError");
const wallet_1 = require("../../../logic/wallet");
const select_token_1 = require("./select-token");
const send_to_1 = require("./send-to");
const enter_amount_1 = require("./enter-amount");
const checkout_1 = require("./checkout");
const send_status_1 = require("../../../components/send-status");
const tonapi_1 = require("../../../logic/tonapi");
const svg_selector_1 = require("../../../assets/svg-selector");
const send_module_css_1 = __importDefault(require("./send.module.css"));
const modalTgStyles = { backgroundColor: 'var(--tg-theme-bg-color)' };
const titleTgStyles = { color: 'var(--tg-theme-text-color)' };
const SendModal = (props) => {
    const tonapi = new tonapi_1.TonApi();
    // const [ position, setPosition ] = useState<number>(0)
    const [transTonConnect, setTransTonConnect] = (0, react_1.useState)(undefined);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)('');
    const { t } = (0, react_i18next_1.useTranslation)();
    const [isSended, setIsSended] = (0, react_1.useState)(false);
    const [isSubmited, setIsSubmited] = (0, react_1.useState)(false);
    const sendMessage = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 1, 120).withFname('Comment');
    const TgObj = sdk_1.default;
    const handleCloseModal = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        props.setShowSendModal(false);
        props.setSkipUserAddress(false);
        props.setPosition(0);
        props.setSendData({
            token: '',
            sendAddress: '',
            tokenAddress: '',
            amount: '',
            availableBalance: '0',
            decimals: 9
        });
        sendMessage.reset();
        setIsSended(false);
        setIsSubmited(false);
        window.document.body.style.overflow = 'auto';
        TgObj.MainButton.hide();
        if (props.tonconnectTransactionProps) {
            props.tonconnectTransactionProps.requestPromise.reject(new SendTransactionError_1.SendTransactionError(props.tonconnectTransactionProps.request.id, protocol_1.SEND_TRANSACTION_ERROR_CODES.USER_REJECTS_ERROR, 'Wallet declined the request'));
            props.setTonconnectTransactionProps(undefined);
        }
        if (props.deployProps) {
            props.setDeployProps(undefined);
        }
    };
    (0, react_1.useEffect)(() => {
        if (props.showSendModal) {
            window.document.body.style.overflow = 'hidden';
            window.document.body.style.position = 'fixed';
            window.document.body.style.width = '100vw';
            props.psw.reset(true, true);
        }
        return () => {
            window.document.body.style.overflow = 'auto';
            window.document.body.style.position = 'relative';
            window.document.body.style.width = '';
        };
    }, [props.showSendModal]);
    let switchText = '';
    switch (props.position) {
        case 0:
            switchText = t('send.select-token');
            break;
        case 1:
            switchText = t('send.send-to');
            break;
        case 2:
            switchText = t('send.enter-amount');
            break;
        case 3:
            switchText = t('send.checkout');
            break;
        case 4:
            switchText = t('send.checkout2');
            break;
        default:
            switchText = t('send.unknown');
            break;
    }
    // qr code state
    const [isScanned, setIsScanned] = (0, react_1.useState)(false);
    const handleBack = () => {
        if (props.position === 0) {
            handleCloseModal();
        }
        else if (props.position === 1) {
            TgObj.HapticFeedback.impactOccurred('medium');
            isScanned ? setIsScanned(false) : props.setPosition(0);
        }
        else if (props.position === 2) {
            TgObj.HapticFeedback.impactOccurred('medium');
            if (props.skipUserAddress) {
                props.setPosition(0);
                return;
            }
            TgObj.MainButton.hide();
            props.setPosition(1);
        }
        else if (props.position === 3) {
            TgObj.HapticFeedback.impactOccurred('medium');
            isSubmited ? setIsSubmited(false) : props.setPosition(2);
            TgObj.MainButton.hide();
        }
        else if (props.position === 4) {
            TgObj.HapticFeedback.impactOccurred('medium');
            props.psw.reset(true, true);
            props.setPosition(3);
        }
    };
    const wall = new wallet_1.CustomWallet((0, getClient_1.getDeLabClient)());
    async function transMakeToCompl() {
        if (!props.sendData.token) {
            // eslint-disable-next-line no-alert
            TgObj.showAlert('error Token');
            props.setPosition(4);
            props.setSendSuccess(false);
            TgObj.MainButton.hide();
            props.eventApi?.updateRes(false);
            return;
        }
        if (props.sendData.token === 'TON') {
            try {
                setIsSended(true);
                TgObj.MainButton.showProgress();
                const coinAmount = Number(props.sendData.amount);
                const checkPsw = await wall.getPrivateKey(props.psw.value);
                if (typeof checkPsw === 'object') {
                    // eslint-disable-next-line no-alert
                    TgObj.showAlert(t('common.incorrect-password'));
                    setIsSended(false);
                    TgObj.MainButton.hideProgress();
                    return;
                }
                let finalTextComment = sendMessage.value;
                if (ton_1.Address.parse(props.sendData.sendAddress).toString({ bounceable: true }) === 'EQAH0G5Xnkaz9kEHoMKgSo7-aPpZ_n8aVvyToGjRodso7Yi6') {
                    finalTextComment = sendMessage.value + '_dwl0f76841b981e951697bf';
                }
                const trans = {
                    to: ton_1.Address.parse(props.sendData.sendAddress),
                    amount: new ton3_1.Coins(coinAmount).toNano().toString(),
                    comment: finalTextComment
                };
                if (props.transFromEvent)
                    trans.data = props.transFromEvent.data;
                if (props.tonconnectTransactionProps && props.tonconnectTransactionProps.messages[0].payload) {
                    console.log('TONCONNECT PAYLOAD and stateInit put in trans.data');
                    trans.data = props.tonconnectTransactionProps.messages[0].payload;
                    trans.init = props.tonconnectTransactionProps.messages[0].stateInit;
                }
                const tr = await wall.signMsg(trans, props.psw.value, setErrorMessage);
                console.log(tr);
                if (!tr) {
                    // eslint-disable-next-line no-alert
                    TgObj.showAlert(t('common.went-wrong'));
                    props.setPosition(4);
                    props.setSendSuccess(false);
                    TgObj.MainButton.hideProgress();
                    TgObj.MainButton.hide();
                    props.eventApi?.updateRes(false);
                    if (props.tonconnectTransactionProps) {
                        props.tonconnectTransactionProps.requestPromise.reject(new SendTransactionError_1.SendTransactionError(props.tonconnectTransactionProps.request.id, protocol_1.SEND_TRANSACTION_ERROR_CODES.USER_REJECTS_ERROR, 'Wallet declined the request'));
                        props.setTonconnectTransactionProps(undefined);
                    }
                    if (props.deployProps) {
                        props.setDeployProps(undefined);
                    }
                }
                else {
                    if (props.tonconnectTransactionProps) {
                        props.tonconnectTransactionProps.requestPromise.resolve('success');
                        props.setTonconnectTransactionProps(undefined);
                    }
                    if (props.deployProps) {
                        props.setDeployProps(undefined);
                    }
                    props.setPosition(4);
                    props.setSendSuccess(true);
                    TgObj.MainButton.hideProgress();
                    // TgObj.MainButton.hide()
                    props.eventApi?.updateRes(true);
                }
                // return tr
            }
            catch (error) {
                const coinAmount = Number(props.sendData.amount);
                let finalTextComment = sendMessage.value;
                if (ton_1.Address.parse(props.sendData.sendAddress).toString({ bounceable: true }) === 'EQAH0G5Xnkaz9kEHoMKgSo7-aPpZ_n8aVvyToGjRodso7Yi6') {
                    finalTextComment = sendMessage.value + '_dwl0f76841b981e951697bf';
                }
                const trans = {
                    to: ton_1.Address.parse(props.sendData.sendAddress),
                    amount: new ton3_1.Coins(coinAmount).toNano().toString(),
                    comment: finalTextComment
                };
                if (props.transFromEvent)
                    trans.data = props.transFromEvent.data;
                if (props.tonconnectTransactionProps && props.tonconnectTransactionProps.messages[0].payload) {
                    console.log('TONCONNECT PAYLOAD and stateInit put in trans.data');
                    trans.data = props.tonconnectTransactionProps.messages[0].payload;
                    trans.init = props.tonconnectTransactionProps.messages[0].stateInit;
                }
                const wall2 = new wallet_1.CustomWallet((0, getClient_1.getHubClient)());
                const tr2 = await wall2.signMsg(trans, props.psw.value, setErrorMessage);
                console.log(tr2);
                if (!tr2) {
                    setErrorMessage('Unknown error ' + String(error));
                    // eslint-disable-next-line no-alert
                    TgObj.showAlert(t('common.went-wrong'));
                    props.setPosition(4);
                    props.setSendSuccess(false);
                    props.eventApi?.updateRes(false);
                    setIsSended(false);
                    console.error(error);
                    TgObj.MainButton.hideProgress();
                    TgObj.MainButton.hide();
                    props.eventApi?.updateRes(false);
                    if (props.tonconnectTransactionProps) {
                        props.tonconnectTransactionProps.requestPromise.reject(new SendTransactionError_1.SendTransactionError(props.tonconnectTransactionProps.request.id, protocol_1.SEND_TRANSACTION_ERROR_CODES.USER_REJECTS_ERROR, 'Wallet declined the request'));
                        props.setTonconnectTransactionProps(undefined);
                    }
                    if (props.deployProps) {
                        props.setDeployProps(undefined);
                    }
                }
                else {
                    if (props.tonconnectTransactionProps) {
                        props.tonconnectTransactionProps.requestPromise.resolve('success');
                        props.setTonconnectTransactionProps(undefined);
                    }
                    if (props.deployProps) {
                        props.setDeployProps(undefined);
                    }
                    props.setPosition(4);
                    props.setSendSuccess(true);
                    TgObj.MainButton.hideProgress();
                    // TgObj.MainButton.hide()
                    props.eventApi?.updateRes(true);
                }
            }
            finally {
                setIsSended(false);
            }
        }
        else {
            try {
                setIsSended(true);
                TgObj.MainButton.showProgress();
                const coinAmount = Number(props.sendData.amount);
                // props.sendData.token.
                const checkPsw = await wall.getPrivateKey(props.psw.value);
                if (typeof checkPsw === 'object') {
                    // eslint-disable-next-line no-alert
                    TgObj.showAlert(t('common.incorrect-password'));
                    setIsSended(false);
                    TgObj.MainButton.hideProgress();
                    return;
                }
                let finalTextComment = sendMessage.value;
                if (ton_1.Address.parse(props.sendData.sendAddress).toString({ bounceable: true }) === 'EQAH0G5Xnkaz9kEHoMKgSo7-aPpZ_n8aVvyToGjRodso7Yi6') {
                    finalTextComment = sendMessage.value + '_dwl0f76841b981e951697bf';
                }
                const trans = {
                    to: ton_1.Address.parse(props.sendData.sendAddress),
                    amount: new ton3_1.Coins(coinAmount * (10 ** props.sendData.decimals)).toString(),
                    comment: finalTextComment
                };
                const tr = await wall.signMsgJetton(trans, props.psw.value, props.sendData.tokenAddress, setErrorMessage);
                console.log(tr);
                // eslint-disable-next-line @typescript-eslint/quotes
                console.log('tokenAddress', props.sendData.tokenAddress);
                if (!tr) {
                    // eslint-disable-next-line no-alert
                    TgObj.showAlert(t('common.went-wrong-fee'));
                    props.setPosition(4);
                    props.setSendSuccess(false);
                    TgObj.MainButton.hideProgress();
                    TgObj.MainButton.hide();
                    props.eventApi?.updateRes(false);
                    setIsSended(false);
                }
                else {
                    setIsSended(false);
                    props.setPosition(4);
                    props.setSendSuccess(true);
                    TgObj.MainButton.hideProgress();
                    // TgObj.MainButton.hide()
                    props.eventApi?.updateRes(true);
                }
            }
            catch (error) {
                const coinAmount = Number(props.sendData.amount);
                let finalTextComment = sendMessage.value;
                if (ton_1.Address.parse(props.sendData.sendAddress).toString({ bounceable: true }) === 'EQAH0G5Xnkaz9kEHoMKgSo7-aPpZ_n8aVvyToGjRodso7Yi6') {
                    finalTextComment = sendMessage.value + '_dwl0f76841b981e951697bf';
                }
                const trans = {
                    to: ton_1.Address.parse(props.sendData.sendAddress),
                    amount: new ton3_1.Coins(coinAmount * (10 ** props.sendData.decimals)).toString(),
                    comment: finalTextComment
                };
                const wall2 = new wallet_1.CustomWallet((0, getClient_1.getHubClient)());
                const tr2 = await wall2.signMsgJetton(trans, props.psw.value, props.sendData.tokenAddress, setErrorMessage);
                console.log(tr2);
                if (!tr2) {
                    console.error(error);
                    setErrorMessage('Unknown jettons error ' + String(error));
                    // eslint-disable-next-line no-alert
                    TgObj.showAlert(t('common.went-wrong-fee'));
                    props.setPosition(4);
                    props.setSendSuccess(false);
                    TgObj.MainButton.hideProgress();
                    TgObj.MainButton.hide();
                    props.eventApi?.updateRes(false);
                    setIsSended(false);
                }
                else {
                    setIsSended(false);
                    props.setPosition(4);
                    props.setSendSuccess(true);
                    TgObj.MainButton.hideProgress();
                    // TgObj.MainButton.hide()
                    props.eventApi?.updateRes(true);
                }
            }
            finally {
                setIsSended(false);
            }
        }
    }
    function getTimeSec() {
        return Math.floor(Date.now() / 1000);
    }
    // tonconnect
    (0, react_1.useEffect)(() => {
        if (props.tonconnectTransactionProps && props.tonconnectTransactionProps.valid_until) {
            if (props.tonconnectTransactionProps.valid_until < getTimeSec()) {
                handleCloseModal();
            }
            console.log('tonconnectTransactionProps IN SEND MODAL', props.tonconnectTransactionProps);
            if (!props.tokensData) {
                return;
            }
            const tonTokenData = props.tokensData.find(asset => asset.token === 'TON');
            if (!tonTokenData) {
                return;
            }
            props.setSendData({
                token: 'TON',
                tokenAddress: tonTokenData.tokenAddress[0],
                availableBalance: tonTokenData.amount,
                sendAddress: props.tonconnectTransactionProps.address,
                amount: (Number(props.tonconnectTransactionProps.amount) / 1.0e9).toString(),
                decimals: 9
            });
            props.setPosition(3);
            // setTransTonConnect({
            //     to: Address.parse(props.tonconnectTransactionProps.address),
            //     amount: new Coins(props.tonconnectTransactionProps.amount).toNano().toString(),
            //     comment: ''
            // })
        }
        else {
            setTransTonConnect(undefined);
        }
    }, [props.tonconnectTransactionProps, props.tonconnectTransactionProps?.valid_until]);
    // deploy
    (0, react_1.useEffect)(() => {
        if (props.deployProps) {
            // if (props.tonconnectTransactionProps.valid_until < getTimeSec()) {
            //     handleCloseModal()
            // }
            console.log('deployProps IN SEND MODAL', props.deployProps);
            if (!props.tokensData) {
                return;
            }
            const tonTokenData = props.tokensData.find(asset => asset.token === 'TON');
            if (!tonTokenData) {
                return;
            }
            props.setSendData({
                token: 'TON',
                tokenAddress: tonTokenData.tokenAddress[0],
                availableBalance: tonTokenData.amount,
                sendAddress: props.deployProps.address,
                amount: props.deployProps.amount,
                decimals: 9
            });
            props.setPosition(3);
        }
        else {
            setTransTonConnect(undefined);
        }
    }, [props.deployProps]);
    console.log('props.sendData', props.sendData);
    (0, react_1.useEffect)(() => {
        const checkDnsSendAddress = async () => {
            if (props.sendData.sendAddress.endsWith('.ton') || props.sendData.sendAddress.endsWith('.t.me')) {
                const res = await tonapi.getAddressByDomainName(props.sendData.sendAddress);
                if (!res || res?.wallet.address.length === 0) {
                    return;
                }
                const addr = ton_1.Address.parse(res?.wallet.address);
                props.setSendData({
                    ...props.sendData,
                    sendAddress: addr.toString({ bounceable: false })
                });
            }
        };
        checkDnsSendAddress();
    }, [props.sendData, props.sendData.sendAddress]);
    return ((0, jsx_runtime_1.jsxs)(modal_1.Modal, { isOpen: props.showSendModal, onClose: handleCloseModal, isCloseButton: false, className: send_module_css_1.default.modal, children: [(0, jsx_runtime_1.jsxs)("div", { className: send_module_css_1.default.modalTop, children: [!props.sendSuccess ? ((0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: send_module_css_1.default.modalTopButton, onClick: handleBack, children: [props.position !== 0 && (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "chevron-left", isTg: props.isTg }), props.position === 0 ? t('common.close') : t('common.back')] })) : ((0, jsx_runtime_1.jsx)("div", { className: send_module_css_1.default.empty })), props.position !== 0 && ((0, jsx_runtime_1.jsx)(de_ui_1.Button, { className: send_module_css_1.default.modalTopButton, onClick: () => {
                            handleCloseModal();
                        }, children: t('common.close') }))] }), (0, jsx_runtime_1.jsxs)("div", { className: `${send_module_css_1.default.content} ${props.position === 0 && send_module_css_1.default.content1}`, children: [props.position === 0 && ((0, jsx_runtime_1.jsx)(select_token_1.SelectToken, { sendData: props.sendData, setSendData: props.setSendData, setPosition: props.setPosition, tokensData: props.tokensData, skipUserAddress: props.skipUserAddress })), props.position === 1 && ((0, jsx_runtime_1.jsx)(send_to_1.SendTo, { sendData: props.sendData, setSendData: props.setSendData, setPosition: props.setPosition, 
                        // @ts-ignore
                        transHistory: props.transHistory, packHistory: props.packHistory, chAU: props.chAU, checkAndReturnAddress: props.checkAndReturnAddress, addressUser: props.addressUser, 
                        // qr code state
                        isScanned: isScanned, setIsScanned: setIsScanned, isTg: props.isTg })), props.position === 2 && ((0, jsx_runtime_1.jsx)(enter_amount_1.EnterAmount, { sendData: props.sendData, setSendData: props.setSendData, position: props.position, setPosition: props.setPosition, isTg: props.isTg })), props.position === 3 && ((0, jsx_runtime_1.jsx)(checkout_1.Checkout, { sendData: props.sendData, psw: props.psw, 
                        // send Transaction
                        transMakeToCompl: transMakeToCompl, isSended: isSended, position: props.position, isTg: props.isTg, isSubmited: isSubmited, setIsSubmited: setIsSubmited, walletBalanceTON: props.walletBalanceTON, priceTON: props.priceTON, message: sendMessage })), props.position === 4 && ((0, jsx_runtime_1.jsx)(send_status_1.SendStatus, { isTg: props.isTg, sendSuccess: props.sendSuccess, setSendSuccess: props.setSendSuccess, isSuccess: props.sendSuccess, sendTo: props.sendData.sendAddress, addressUser: props.addressUser, errorMessage: errorMessage }))] }), (0, jsx_runtime_1.jsx)("div", { className: send_module_css_1.default.background }), props.position !== 4 && (0, jsx_runtime_1.jsx)("div", { className: send_module_css_1.default.background }), props.position === 4 && (props.sendSuccess ? (0, jsx_runtime_1.jsx)("div", { className: send_module_css_1.default.backgroundSuccess }) : (0, jsx_runtime_1.jsx)("div", { className: send_module_css_1.default.backgroundError }))] }));
};
exports.SendModal = SendModal;
